module.exports = __webpack_public_path__ + "img/pieceOneImg1.a85455a.png";